import { lazy } from 'react';

import withSuspense from '../../../hoc/withSuspense';
import validateAuthState from '../../../utils/auth/validateAuthState';
import { APP, FORGOT_PASSWORD, LOGIN, RESET_PASSWORD, ROOT } from '../constant/ROUTE';

// Login
const Login = lazy(() => import('../../public/pages/login/login'));
const LoginWithSuspense = withSuspense(Login);

// Forgot Password
const ForgotPassword = lazy(() => import('../../public/pages/forgetPassword/forgetPassword'));
const ForgotPasswordWithSuspense = withSuspense(ForgotPassword);

// Reset Password
const ResetPassword = lazy(() => import('../../public/pages/resetPassword/resetPassword'));
const ResetPasswordWithSuspense = withSuspense(ResetPassword);

// App Main (after login)
const AppMain = lazy(() => import('../../layout/appMain'));
const AppMainWithSuspense = withSuspense(AppMain);

// Before enter callback for all auth routes
const authCheckMiddleware = (next) => {
  const isAuthenticated = validateAuthState();
  if (isAuthenticated) {
    return next(APP); // if already logged in -> go to app main
  } else {
    return next();
  }
};

// Route configurations
function getRouteConfigs() {
  return [
    {
      path: LOGIN,
      exact: true,
      element: <LoginWithSuspense />,
      beforeEnter: authCheckMiddleware,
      meta: { title: 'Login' },
    },
    {
      path: FORGOT_PASSWORD,
      exact: true,
      element: <ForgotPasswordWithSuspense />,
      beforeEnter: authCheckMiddleware,
      meta: { title: 'Forgot Password' },
    },
    {
      path: RESET_PASSWORD,
      exact: true,
      element: <ResetPasswordWithSuspense />,
      beforeEnter: authCheckMiddleware,
      meta: { title: 'Reset Password' },
    },
    {
      // PUBLIC MAIN -> all routes after login will go inside AppMain
      path: APP,
      element: <AppMainWithSuspense />,
    },
    {
      // NOT FOUND ROUTE
      path: '*',
      redirect: ROOT,
    },
  ];
}

export default getRouteConfigs;
